var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco00(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 312.3 312.3",
    enableBackground: "new 0 0 312.3 312.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#181818",
    points: "304.5,249 275.3,249 275.3,238.3 293.8,238.3 293.8,46.6 17.7,46.6 17.7,238.3 36.2,238.3  36.2,249 6.9,249 6.9,35.9 304.5,35.9  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M304.5,46.6H6.9V0h297.6V46.6z M17.7,35.9h276.1V10.8H17.7V35.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 17.9,
    fill: "#181818",
    width: 10.8,
    height: 10.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 17.9,
    fill: "#181818",
    width: 10.8,
    height: 10.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.1,
    y: 17.9,
    fill: "#181818",
    width: 10.8,
    height: 10.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M155.7,312.4c-55.1,0-100-44.9-100-100c0-55.1,44.9-100,100-100c55.1,0,100,44.8,100,100 C255.7,267.5,210.9,312.4,155.7,312.4z M155.7,123.2c-49.2,0-89.2,40-89.2,89.2c0,49.2,40,89.2,89.2,89.2 c49.2,0,89.2-40,89.2-89.2C244.9,163.2,204.9,123.2,155.7,123.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 91.7,
    fill: "#181818",
    width: 10.8,
    height: 26.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M167.5,108.9h-23.6c-4.6,0-8.9-1.8-12.2-5c-3.2-3.2-5-7.6-5-12.2c0-4.6,1.8-8.9,5-12.2 c3.3-3.2,7.6-5,12.2-5h23.6c4.6,0,8.9,1.8,12.2,5c3.3,3.3,5,7.6,5,12.2c0,4.6-1.8,8.9-5,12.2 C176.5,107.1,172.1,108.9,167.5,108.9z M143.9,85.3c-1.7,0-3.4,0.7-4.6,1.9c-1.2,1.2-1.9,2.8-1.9,4.6c0,1.7,0.7,3.4,1.9,4.6 c1.2,1.2,2.8,1.9,4.6,1.9h23.6c1.7,0,3.4-0.7,4.6-1.9c1.2-1.2,1.9-2.8,1.9-4.6c0-1.7-0.7-3.4-1.9-4.6c-1.2-1.2-2.8-1.9-4.6-1.9 H143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M240.4,148.7l-7.6-7.6l5.5-5.6c0.3-0.3,0.3-0.6,0.3-0.7c0-0.1,0-0.4-0.3-0.7l-4.4-4.4 c-0.3-0.3-1.1-0.2-1.3,0l-5.5,5.6l-7.6-7.6l5.6-5.6c2.2-2.2,5.2-3.4,8.3-3.4c3.2,0,6.1,1.2,8.3,3.5l4.4,4.4 c2.2,2.2,3.5,5.2,3.5,8.3c0,3.1-1.2,6-3.5,8.3L240.4,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M71.1,148.7l-5.6-5.6c-2.2-2.2-3.4-5.1-3.4-8.2c0-3.1,1.2-6.1,3.4-8.3l4.5-4.5c2.2-2.2,5.1-3.4,8.2-3.4 c3.1,0,6.1,1.2,8.3,3.4l5.6,5.6l-7.6,7.6l-5.6-5.6c-0.3-0.3-1-0.4-1.3,0l-4.5,4.5c-0.3,0.3-0.3,0.6-0.3,0.7c0,0.1,0,0.3,0.3,0.6 l5.6,5.6L71.1,148.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113.5,
    y: 143.5,
    transform: "matrix(0.501 0.8654 -0.8654 0.501 188.282 -28.7373)",
    fill: "#181818",
    width: 11,
    height: 10.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.7,
    y: 170.4,
    transform: "matrix(0.8669 0.4985 -0.4985 0.8669 99.88 -22.5818)",
    fill: "#181818",
    width: 11,
    height: 10.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.9,
    y: 207,
    fill: "#181818",
    width: 11,
    height: 10.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.8,
    y: 243.5,
    transform: "matrix(0.5004 0.8658 -0.8658 0.5004 261.7038 44.5785)",
    fill: "#181818",
    width: 10.8,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.7,
    y: 270.4,
    transform: "matrix(0.8658 0.5004 -0.5004 0.8658 154.0282 -22.5555)",
    fill: "#181818",
    width: 10.8,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 280.2,
    fill: "#181818",
    width: 10.8,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.9,
    y: 270.5,
    transform: "matrix(0.4976 0.8674 -0.8674 0.4976 335.9281 -28.2677)",
    fill: "#181818",
    width: 11,
    height: 10.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.7,
    y: 243.7,
    transform: "matrix(0.8667 0.4988 -0.4988 0.8667 153.4481 -76.1477)",
    fill: "#181818",
    width: 11.1,
    height: 10.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M155.7,229.6c-9.5,0-17.2-7.7-17.2-17.2c0-9.5,7.7-17.2,17.2-17.2c9.5,0,17.2,7.7,17.2,17.2 C172.9,221.9,165.2,229.6,155.7,229.6z M155.7,205.9c-3.5,0-6.4,2.9-6.4,6.4c0,3.6,2.9,6.5,6.4,6.5c3.5,0,6.4-2.9,6.4-6.5 C162.2,208.8,159.3,205.9,155.7,205.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.5,
    y: 207,
    fill: "#181818",
    width: 30,
    height: 10.8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M234.4,212.4h-10.8c0-37.5-30.5-67.9-67.9-67.9v-10.8C199.1,133.7,234.4,169,234.4,212.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco00);
export default __webpack_public_path__ + "static/media/ico_00.4108aa8809f586e95b88660a8e5ee0ea.svg";
export { ForwardRef as ReactComponent };